import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer>
    <Link to="/imprint">Impressum</Link>
  </footer>
);

export default Footer;
